// Translations for AFY - All For You
export const translations = {
  en: {
    // Navigation
    nav: {
      services: "Services",
      providers: "Providers",
      login: "Login",
      register: "Sign Up",
      dashboard: "Dashboard",
      bookings: "My Bookings",
      messages: "Messages",
      profile: "My Profile",
      logout: "Logout",
      becomeProvider: "Become a Provider"
    },
    // Home page
    home: {
      heroTitle: "Your personal services,",
      heroTitleAccent: "delivered to your door",
      heroSubtitle: "Book trusted professionals for all your needs - from private chefs to home cleaning, fitness coaching, and more.",
      searchPlaceholder: "Search providers, services...",
      allCategories: "All Categories",
      search: "Search",
      howItWorks: "How It Works",
      howItWorksSubtitle: "Book your service in just a few clicks",
      step1Title: "Choose a Service",
      step1Desc: "Browse providers by category and specialty",
      step2Title: "Book a Date",
      step2Desc: "Select the day, time, and your requirements",
      step3Title: "Pay Securely",
      step3Desc: "Secure payment and instant confirmation",
      featuredProviders: "Top Rated Providers",
      featuredSubtitle: "Discover the best professionals in Hamburg",
      viewAll: "View All",
      stats: {
        providers: "Professional Providers",
        bookings: "Bookings Completed",
        avgRating: "Average Rating",
        coverage: "Hamburg Coverage"
      },
      ctaTitle: "Are you a professional?",
      ctaSubtitle: "Join our platform and offer your services to clients in Hamburg.",
      ctaButton: "Become a Partner"
    },
    // Services/Categories
    categories: {
      chef: "Private Chef",
      cleaning: "Cleaning",
      babysitting: "Babysitting",
      tutoring: "Tutoring",
      fitness: "Fitness Coach",
      beauty: "Beauty & Wellness",
      handyman: "Handyman",
      gardening: "Gardening",
      pet_care: "Pet Care",
      elderly_care: "Elderly Care"
    },
    // Ranks
    ranks: {
      pro: "Pro",
      elite: "Elite",
      master: "Master",
      grandmaster: "Grand Master",
      legendary: "Legendary"
    },
    // Provider
    provider: {
      perHour: "/hour",
      perPerson: "pers.",
      perPersonPricing: "Per person rate",
      pricing: "Pricing",
      billingMode: "Billing mode",
      hourlyRate: "Hourly rate",
      perPersonRate: "Per person rate",
      hourlyDescription: "Client pays based on the number of hours booked",
      perPersonDescription: "Client pays based on the number of people",
      stripeActive: "Stripe account active",
      canReceivePayments: "You can receive payments",
      configRequired: "Configuration required",
      createStripeToReceive: "Create your Stripe account to receive payments",
      configureStripe: "Configure Stripe",
      minHours: "Min",
      maxCapacity: "Max",
      available: "Available",
      unavailable: "Unavailable",
      reviews: "reviews",
      missions: "missions",
      commission: "Commission",
      specialties: "Specialties",
      languages: "Languages",
      bookNow: "Book Now",
      contactProvider: "Contact",
      gallery: "Gallery",
      about: "About"
    },
    // Booking
    booking: {
      createBooking: "Book",
      date: "Event Date",
      time: "Start Time",
      duration: "Duration (hours)",
      capacity: "Number of people",
      address: "Address",
      phone: "Phone",
      notes: "Notes (optional)",
      subtotal: "Subtotal",
      serviceFee: "Service Fee",
      total: "Total",
      confirm: "Confirm Booking",
      pending: "Pending",
      confirmed: "Confirmed",
      paid: "Paid",
      completed: "Completed",
      cancelled: "Cancelled",
      payNow: "Pay Now",
      cancel: "Cancel",
      accept: "Accept",
      decline: "Decline",
      complete: "Mark Complete"
    },
    // Auth
    auth: {
      loginTitle: "Login",
      loginSubtitle: "Access your account to manage your bookings",
      registerTitle: "Create Account",
      registerSubtitle: "Join the AFY community",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      name: "Full Name",
      client: "Client",
      provider: "Provider",
      continueGoogle: "Continue with Google",
      orEmail: "or by email",
      submit: "Submit",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      createAccount: "Create Account",
      personalInfo: "Personal Information",
      fullName: "Full Name",
      professionalEmail: "Professional Email",
      phone: "Phone",
      confirm: "Confirm",
      minChars: "Min. 6 characters",
      next: "Next",
      back: "Back",
      yourService: "Your Service",
      serviceCategory: "Service Category",
      chooseCategory: "Choose a category",
      descriptionBio: "Description / Bio",
      describePlaceholder: "Describe your experience and services...",
      specialties: "Specialties",
      hourlyRate: "Hourly Rate (EUR)",
      spokenLanguages: "Spoken Languages",
      professionalVerification: "Professional Verification",
      verificationDescription: "To ensure the quality of our platform, please provide a professional registration document (trade license, business registration, etc.).",
      clickToUpload: "Click to upload",
      clickToChange: "Click to change",
      documentOptional: "This document is optional but recommended. Verified providers receive a trust badge.",
      finalize: "Complete Registration",
      registering: "Registering",
      fillAllFields: "Please fill in all fields",
      passwordMismatch: "Passwords do not match",
      passwordTooShort: "Password too short (min. 6 characters)",
      forgotPassword: "Forgot your password?",
      forgotPasswordSubtitle: "Enter your email and we'll send you a reset link",
      sendResetLink: "Send Reset Link",
      resetEmailSent: "Email Sent!",
      resetEmailSentDesc: "Check your inbox for the password reset link. It expires in 1 hour.",
      backToLogin: "Back to Login",
      newPassword: "New Password",
      chooseNewPassword: "Choose a new password for your account",
      resetPassword: "Reset Password",
      invalidResetLink: "This reset link is invalid or has expired.",
      requestNewLink: "Request a New Link",
      passwordUpdated: "Password Updated!",
      passwordUpdatedDesc: "Your password has been changed. You can now log in.",
      changePassword: "Change Password",
      changePasswordDesc: "Update your account password",
      currentPassword: "Current Password",
      passwordChanged: "Password changed successfully"
    },
    // Dashboard
    dashboard: {
      welcome: "Welcome",
      upcomingBookings: "Upcoming Bookings",
      pendingRequests: "Pending Requests",
      pastBookings: "Past Bookings",
      quickActions: "Quick Actions",
      findProvider: "Find a Provider",
      myMessages: "My Messages",
      totalEarnings: "Total Earnings",
      monthEarnings: "This Month",
      completedMissions: "Completed Missions",
      rankProgress: "Rank Progress",
      editProfile: "Edit Profile"
    },
    // Reviews
    review: {
      leaveReview: "Leave a Review",
      rating: "Rating",
      comment: "Comment",
      publish: "Publish",
      noReviews: "No reviews yet"
    },
    // Messages
    messages: {
      title: "Messages",
      noConversations: "No conversations",
      selectConversation: "Select a conversation to start",
      typeMessage: "Type your message...",
      send: "Send"
    },
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      save: "Save",
      cancel: "Cancel",
      back: "Back",
      next: "Next",
      manage: "Manage",
      noResults: "No results found",
      clearFilters: "Clear filters",
      filters: "Filters",
      priceRange: "Price Range",
      language: "Language",
      hours: "hours",
      person: "person",
      people: "people"
    },
    // Footer
    footer: {
      tagline: "Book trusted professionals for all your personal service needs in Hamburg.",
      navigation: "Navigation",
      support: "Support",
      faq: "FAQ",
      contact: "Contact",
      privacy: "Privacy Policy",
      rights: "All rights reserved"
    },
    // Verification
    verification: {
      pendingTitle: "Account pending verification",
      pendingMessage: "Your profile is being reviewed by our team. You cannot appear in searches or publish content yet.",
      rejectedTitle: "Verification rejected",
      rejectedMessage: "Your request has been rejected. Please update your documents and try again.",
      cannotPost: "Your account is pending verification. You cannot publish yet."
    },
    // Blog
    blog: {
      myPosts: "My Publications",
      publication: "publication",
      publications: "publications",
      newPost: "Publish",
      noPosts: "No publications",
      noPostsSubtitle: "Share your work and attract new clients!",
      createFirst: "Create my first publication",
      newPostTitle: "New publication",
      addPhotos: "Add photos",
      describeWork: "Describe your work...",
      publish: "Publish",
      publishing: "Publishing...",
      postCreated: "Publication created!",
      deleteConfirm: "Delete this publication?",
      postDeleted: "Publication deleted",
      viewPosts: "View publications",
      backToProfile: "Back to profile",
      viewProfile: "View profile",
      noPostsYet: "No publications yet",
      noComments: "No comments",
      addComment: "Add a comment...",
      loginToLike: "Log in to like",
      loginToComment: "Log in to comment",
      justNow: "just now",
      minutesAgo: "min ago",
      hoursAgo: "h ago",
      daysAgo: "d ago"
    },
    // Invoice
    invoice: {
      title: "Invoice",
      generate: "Generate Invoice",
      view: "View Invoice",
      sent: "Invoice Sent",
      providerRate: "Provider Rate",
      serviceDuration: "Service Duration",
      subtotal: "Subtotal (provider)",
      commission: "Platform Commission",
      commissionRate: "Commission Rate",
      totalCharged: "Total Charged",
      invoiceNumber: "Invoice No.",
      invoiceDate: "Invoice Date",
      serviceDate: "Service Date",
      billTo: "Bill To",
      serviceBy: "Service By",
      noInvoice: "No invoice yet",
      generating: "Generating...",
      generated: "Invoice generated",
      priceIncludesCommission: "Price includes service fees"
    },
    // Payment
    payment: {
      checking: "Verifying payment...",
      pleaseWait: "Please wait while we confirm your payment.",
      success: "Payment successful!",
      confirmed: "Your booking has been confirmed.",
      viewBookings: "View my bookings",
      backHome: "Back to home",
      processing: "Payment processing",
      processingDesc: "Your payment is being processed. You will receive a confirmation by email.",
      error: "Payment error",
      errorDesc: "An error occurred during payment. Please try again.",
      backToBookings: "Back to bookings",
      expired: "Session expired"
    },
    // Bank Info
    bank: {
      title: "Bank Information",
      description: "Enter your bank details to receive payments for your services.",
      accountHolder: "Account Holder",
      bankName: "Bank Name",
      save: "Save Bank Details",
      saved: "Bank information saved"
    }
  },
  de: {
    nav: {
      services: "Dienste",
      providers: "Anbieter",
      login: "Anmelden",
      register: "Registrieren",
      dashboard: "Dashboard",
      bookings: "Meine Buchungen",
      messages: "Nachrichten",
      profile: "Mein Profil",
      logout: "Abmelden",
      becomeProvider: "Anbieter werden"
    },
    home: {
      heroTitle: "Ihre persönlichen Dienste,",
      heroTitleAccent: "zu Ihnen nach Hause geliefert",
      heroSubtitle: "Buchen Sie vertrauenswürdige Fachleute für all Ihre Bedürfnisse - von Privatköchen bis hin zur Hausreinigung und Fitness-Coaching.",
      searchPlaceholder: "Anbieter, Dienste suchen...",
      allCategories: "Alle Kategorien",
      search: "Suchen",
      howItWorks: "So funktioniert's",
      howItWorksSubtitle: "Buchen Sie Ihren Service in wenigen Klicks",
      step1Title: "Wählen Sie einen Service",
      step1Desc: "Durchsuchen Sie Anbieter nach Kategorie und Spezialität",
      step2Title: "Buchen Sie einen Termin",
      step2Desc: "Wählen Sie Tag, Uhrzeit und Ihre Anforderungen",
      step3Title: "Zahlen Sie sicher",
      step3Desc: "Sichere Zahlung und sofortige Bestätigung",
      featuredProviders: "Top bewertete Anbieter",
      featuredSubtitle: "Entdecken Sie die besten Fachleute in Hamburg",
      viewAll: "Alle anzeigen",
      stats: {
        providers: "Professionelle Anbieter",
        bookings: "Abgeschlossene Buchungen",
        avgRating: "Durchschnittsbewertung",
        coverage: "Hamburg Abdeckung"
      },
      ctaTitle: "Sind Sie ein Profi?",
      ctaSubtitle: "Treten Sie unserer Plattform bei und bieten Sie Ihre Dienste in Hamburg an.",
      ctaButton: "Partner werden"
    },
    categories: {
      chef: "Privatkoch",
      cleaning: "Reinigung",
      babysitting: "Kinderbetreuung",
      tutoring: "Nachhilfe",
      fitness: "Fitness-Coach",
      beauty: "Schönheit & Wellness",
      handyman: "Handwerker",
      gardening: "Gartenarbeit",
      pet_care: "Tierpflege",
      elderly_care: "Altenpflege"
    },
    ranks: {
      pro: "Pro",
      elite: "Elite",
      master: "Meister",
      grandmaster: "Großmeister",
      legendary: "Legendär"
    },
    provider: {
      perHour: "/Stunde",
      perPerson: "Pers.",
      perPersonPricing: "Preis pro Person",
      pricing: "Preisgestaltung",
      billingMode: "Abrechnungsmodus",
      hourlyRate: "Stundensatz",
      perPersonRate: "Preis pro Person",
      hourlyDescription: "Der Kunde zahlt nach der Anzahl der gebuchten Stunden",
      perPersonDescription: "Der Kunde zahlt nach der Anzahl der Personen",
      stripeActive: "Stripe-Konto aktiv",
      canReceivePayments: "Sie können Zahlungen empfangen",
      configRequired: "Konfiguration erforderlich",
      createStripeToReceive: "Erstellen Sie Ihr Stripe-Konto, um Zahlungen zu empfangen",
      configureStripe: "Stripe konfigurieren",
      minHours: "Min",
      maxCapacity: "Max",
      available: "Verfügbar",
      unavailable: "Nicht verfügbar",
      reviews: "Bewertungen",
      missions: "Aufträge",
      commission: "Provision",
      specialties: "Spezialitäten",
      languages: "Sprachen",
      bookNow: "Jetzt buchen",
      contactProvider: "Kontakt",
      gallery: "Galerie",
      about: "Über"
    },
    booking: {
      createBooking: "Buchen",
      date: "Datum",
      time: "Startzeit",
      duration: "Dauer (Stunden)",
      capacity: "Anzahl Personen",
      address: "Adresse",
      phone: "Telefon",
      notes: "Notizen (optional)",
      subtotal: "Zwischensumme",
      serviceFee: "Servicegebühr",
      total: "Gesamt",
      confirm: "Buchung bestätigen",
      pending: "Ausstehend",
      confirmed: "Bestätigt",
      paid: "Bezahlt",
      completed: "Abgeschlossen",
      cancelled: "Storniert",
      payNow: "Jetzt bezahlen",
      cancel: "Stornieren",
      accept: "Annehmen",
      decline: "Ablehnen",
      complete: "Abschließen"
    },
    auth: {
      loginTitle: "Anmelden",
      loginSubtitle: "Greifen Sie auf Ihr Konto zu, um Ihre Buchungen zu verwalten",
      registerTitle: "Konto erstellen",
      registerSubtitle: "Werden Sie Teil der AFY-Community",
      email: "E-Mail",
      password: "Passwort",
      confirmPassword: "Passwort bestätigen",
      name: "Vollständiger Name",
      client: "Kunde",
      provider: "Anbieter",
      continueGoogle: "Mit Google fortfahren",
      orEmail: "oder per E-Mail",
      submit: "Absenden",
      noAccount: "Noch kein Konto?",
      hasAccount: "Bereits ein Konto?",
      createAccount: "Konto erstellen",
      personalInfo: "Persönliche Daten",
      fullName: "Vollständiger Name",
      professionalEmail: "Geschäftliche E-Mail",
      phone: "Telefon",
      confirm: "Bestätigen",
      minChars: "Mind. 6 Zeichen",
      next: "Weiter",
      back: "Zurück",
      yourService: "Ihr Service",
      serviceCategory: "Servicekategorie",
      chooseCategory: "Kategorie wählen",
      descriptionBio: "Beschreibung / Bio",
      describePlaceholder: "Beschreiben Sie Ihre Erfahrung und Dienstleistungen...",
      specialties: "Spezialgebiete",
      hourlyRate: "Stundensatz (EUR)",
      spokenLanguages: "Gesprochene Sprachen",
      professionalVerification: "Berufliche Verifizierung",
      verificationDescription: "Um die Qualität unserer Plattform sicherzustellen, laden Sie bitte ein Gewerbedokument hoch (Gewerbeschein, Handwerkskarte usw.).",
      clickToUpload: "Klicken zum Hochladen",
      clickToChange: "Klicken zum Ändern",
      documentOptional: "Dieses Dokument ist optional, aber empfohlen. Verifizierte Anbieter erhalten ein Vertrauensabzeichen.",
      finalize: "Registrierung abschließen",
      registering: "Registrierung läuft",
      fillAllFields: "Bitte füllen Sie alle Felder aus",
      passwordMismatch: "Passwörter stimmen nicht überein",
      passwordTooShort: "Passwort zu kurz (min. 6 Zeichen)",
      forgotPassword: "Passwort vergessen?",
      forgotPasswordSubtitle: "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Link zum Zurücksetzen",
      sendResetLink: "Link senden",
      resetEmailSent: "E-Mail gesendet!",
      resetEmailSentDesc: "Prüfen Sie Ihren Posteingang. Der Link ist 1 Stunde gültig.",
      backToLogin: "Zurück zur Anmeldung",
      newPassword: "Neues Passwort",
      chooseNewPassword: "Wählen Sie ein neues Passwort für Ihr Konto",
      resetPassword: "Passwort zurücksetzen",
      invalidResetLink: "Dieser Link ist ungültig oder abgelaufen.",
      requestNewLink: "Neuen Link anfordern",
      passwordUpdated: "Passwort aktualisiert!",
      passwordUpdatedDesc: "Ihr Passwort wurde geändert. Sie können sich jetzt anmelden.",
      changePassword: "Passwort ändern",
      changePasswordDesc: "Aktualisieren Sie Ihr Kontopasswort",
      currentPassword: "Aktuelles Passwort",
      passwordChanged: "Passwort erfolgreich geändert"
    },
    dashboard: {
      welcome: "Willkommen",
      upcomingBookings: "Anstehende Buchungen",
      pendingRequests: "Ausstehende Anfragen",
      pastBookings: "Vergangene Buchungen",
      quickActions: "Schnellaktionen",
      findProvider: "Anbieter finden",
      myMessages: "Meine Nachrichten",
      totalEarnings: "Gesamteinnahmen",
      monthEarnings: "Diesen Monat",
      completedMissions: "Abgeschlossene Aufträge",
      rankProgress: "Rangfortschritt",
      editProfile: "Profil bearbeiten"
    },
    review: {
      leaveReview: "Bewertung abgeben",
      rating: "Bewertung",
      comment: "Kommentar",
      publish: "Veröffentlichen",
      noReviews: "Noch keine Bewertungen"
    },
    messages: {
      title: "Nachrichten",
      noConversations: "Keine Unterhaltungen",
      selectConversation: "Wählen Sie eine Unterhaltung aus",
      typeMessage: "Nachricht eingeben...",
      send: "Senden"
    },
    common: {
      loading: "Laden...",
      error: "Fehler",
      success: "Erfolg",
      save: "Speichern",
      cancel: "Abbrechen",
      back: "Zurück",
      next: "Weiter",
      manage: "Verwalten",
      noResults: "Keine Ergebnisse gefunden",
      clearFilters: "Filter löschen",
      filters: "Filter",
      priceRange: "Preisbereich",
      language: "Sprache",
      hours: "Stunden",
      person: "Person",
      people: "Personen"
    },
    footer: {
      tagline: "Buchen Sie vertrauenswürdige Fachleute für all Ihre persönlichen Servicebedürfnisse in Hamburg.",
      navigation: "Navigation",
      support: "Support",
      faq: "FAQ",
      contact: "Kontakt",
      privacy: "Datenschutz",
      rights: "Alle Rechte vorbehalten"
    },
    verification: {
      pendingTitle: "Konto wird überprüft",
      pendingMessage: "Ihr Profil wird von unserem Team überprüft. Sie können noch nicht in den Suchergebnissen erscheinen oder Inhalte veröffentlichen.",
      rejectedTitle: "Überprüfung abgelehnt",
      rejectedMessage: "Ihr Antrag wurde abgelehnt. Bitte aktualisieren Sie Ihre Dokumente und versuchen Sie es erneut.",
      cannotPost: "Ihr Konto wird derzeit überprüft. Sie können noch nicht veröffentlichen."
    },
    blog: {
      myPosts: "Meine Beiträge",
      publication: "Beitrag",
      publications: "Beiträge",
      newPost: "Veröffentlichen",
      noPosts: "Keine Beiträge",
      noPostsSubtitle: "Teilen Sie Ihre Arbeit und gewinnen Sie neue Kunden!",
      createFirst: "Ersten Beitrag erstellen",
      newPostTitle: "Neuer Beitrag",
      addPhotos: "Fotos hinzufügen",
      describeWork: "Beschreiben Sie Ihre Arbeit...",
      publish: "Veröffentlichen",
      publishing: "Wird veröffentlicht...",
      postCreated: "Beitrag erstellt!",
      deleteConfirm: "Diesen Beitrag löschen?",
      postDeleted: "Beitrag gelöscht",
      viewPosts: "Beiträge ansehen",
      backToProfile: "Zurück zum Profil",
      viewProfile: "Profil ansehen",
      noPostsYet: "Noch keine Beiträge",
      noComments: "Keine Kommentare",
      addComment: "Kommentar hinzufügen...",
      loginToLike: "Anmelden zum Liken",
      loginToComment: "Anmelden zum Kommentieren",
      justNow: "gerade eben",
      minutesAgo: "Min.",
      hoursAgo: "Std.",
      daysAgo: "T."
    },
    invoice: {
      title: "Rechnung",
      generate: "Rechnung erstellen",
      view: "Rechnung ansehen",
      sent: "Rechnung gesendet",
      providerRate: "Anbieterpreis",
      serviceDuration: "Servicedauer",
      subtotal: "Zwischensumme (Anbieter)",
      commission: "Plattform-Provision",
      commissionRate: "Provisionssatz",
      totalCharged: "Gesamtbetrag",
      invoiceNumber: "Rechnungsnr.",
      invoiceDate: "Rechnungsdatum",
      serviceDate: "Servicedatum",
      billTo: "Rechnung an",
      serviceBy: "Service von",
      noInvoice: "Noch keine Rechnung",
      generating: "Wird erstellt...",
      generated: "Rechnung erstellt",
      priceIncludesCommission: "Preis inkl. Servicegebühren"
    },
    payment: {
      checking: "Zahlung wird überprüft...",
      pleaseWait: "Bitte warten Sie, während wir Ihre Zahlung bestätigen.",
      success: "Zahlung erfolgreich!",
      confirmed: "Ihre Buchung wurde bestätigt.",
      viewBookings: "Meine Buchungen ansehen",
      backHome: "Zurück zur Startseite",
      processing: "Zahlung wird verarbeitet",
      processingDesc: "Ihre Zahlung wird verarbeitet. Sie erhalten eine Bestätigung per E-Mail.",
      error: "Zahlungsfehler",
      errorDesc: "Bei der Zahlung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      backToBookings: "Zurück zu den Buchungen",
      expired: "Sitzung abgelaufen"
    },
    bank: {
      title: "Bankverbindung",
      description: "Geben Sie Ihre Bankdaten ein, um Zahlungen für Ihre Dienstleistungen zu erhalten.",
      accountHolder: "Kontoinhaber",
      bankName: "Bankname",
      save: "Bankdaten speichern",
      saved: "Bankverbindung gespeichert"
    }
  },
  fr: {
    nav: {
      services: "Services",
      providers: "Prestataires",
      login: "Connexion",
      register: "S'inscrire",
      dashboard: "Tableau de bord",
      bookings: "Mes Réservations",
      messages: "Messages",
      profile: "Mon Profil",
      logout: "Déconnexion",
      becomeProvider: "Devenir Prestataire"
    },
    home: {
      heroTitle: "Vos services personnels,",
      heroTitleAccent: "livrés chez vous",
      heroSubtitle: "Réservez des professionnels de confiance pour tous vos besoins - chefs privés, ménage, coaching sportif et plus.",
      searchPlaceholder: "Rechercher prestataires, services...",
      allCategories: "Toutes catégories",
      search: "Rechercher",
      howItWorks: "Comment ça marche",
      howItWorksSubtitle: "Réservez votre service en quelques clics",
      step1Title: "Choisissez un service",
      step1Desc: "Parcourez les prestataires par catégorie et spécialité",
      step2Title: "Réservez une date",
      step2Desc: "Sélectionnez le jour, l'heure et vos besoins",
      step3Title: "Payez en sécurité",
      step3Desc: "Paiement sécurisé et confirmation instantanée",
      featuredProviders: "Prestataires populaires",
      featuredSubtitle: "Découvrez les meilleurs professionnels de Hamburg",
      viewAll: "Voir tout",
      stats: {
        providers: "Prestataires professionnels",
        bookings: "Réservations effectuées",
        avgRating: "Note moyenne",
        coverage: "Couverture Hamburg"
      },
      ctaTitle: "Vous êtes professionnel ?",
      ctaSubtitle: "Rejoignez notre plateforme et proposez vos services aux clients de Hamburg.",
      ctaButton: "Devenir Partenaire"
    },
    categories: {
      chef: "Chef Privé",
      cleaning: "Ménage",
      babysitting: "Garde d'enfants",
      tutoring: "Cours particuliers",
      fitness: "Coach sportif",
      beauty: "Beauté & Bien-être",
      handyman: "Bricolage",
      gardening: "Jardinage",
      pet_care: "Garde d'animaux",
      elderly_care: "Aide aux personnes âgées"
    },
    ranks: {
      pro: "Pro",
      elite: "Élite",
      master: "Maître",
      grandmaster: "Grand Maître",
      legendary: "Légendaire"
    },
    provider: {
      perHour: "/heure",
      perPerson: "pers.",
      perPersonPricing: "Prix par personne",
      pricing: "Tarification",
      billingMode: "Mode de facturation",
      hourlyRate: "Tarif à l'heure",
      perPersonRate: "Tarif par personne",
      hourlyDescription: "Le client paie en fonction du nombre d'heures réservées",
      perPersonDescription: "Le client paie en fonction du nombre de personnes",
      stripeActive: "Compte Stripe actif",
      canReceivePayments: "Vous pouvez recevoir des paiements",
      configRequired: "Configuration requise",
      createStripeToReceive: "Créez votre compte Stripe pour recevoir des paiements",
      configureStripe: "Configurer Stripe",
      minHours: "Min",
      maxCapacity: "Max",
      available: "Disponible",
      unavailable: "Indisponible",
      reviews: "avis",
      missions: "missions",
      commission: "Commission",
      specialties: "Spécialités",
      languages: "Langues",
      bookNow: "Réserver",
      contactProvider: "Contacter",
      gallery: "Galerie",
      about: "À propos"
    },
    booking: {
      createBooking: "Réserver",
      date: "Date de l'événement",
      time: "Heure de début",
      duration: "Durée (heures)",
      capacity: "Nombre de personnes",
      address: "Adresse",
      phone: "Téléphone",
      notes: "Notes (optionnel)",
      subtotal: "Sous-total",
      serviceFee: "Frais de service",
      total: "Total",
      confirm: "Confirmer la réservation",
      pending: "En attente",
      confirmed: "Confirmée",
      paid: "Payée",
      completed: "Terminée",
      cancelled: "Annulée",
      payNow: "Payer maintenant",
      cancel: "Annuler",
      accept: "Accepter",
      decline: "Refuser",
      complete: "Marquer terminée"
    },
    auth: {
      loginTitle: "Connexion",
      loginSubtitle: "Accédez à votre compte pour gérer vos réservations",
      registerTitle: "Créer un compte",
      registerSubtitle: "Rejoignez la communauté AFY",
      email: "Email",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      name: "Nom complet",
      client: "Client",
      provider: "Prestataire",
      continueGoogle: "Continuer avec Google",
      orEmail: "ou par email",
      submit: "Envoyer",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      createAccount: "Créer un compte",
      forgotPassword: "Mot de passe oublié ?",
      forgotPasswordSubtitle: "Entrez votre email et nous vous enverrons un lien de réinitialisation",
      sendResetLink: "Envoyer le lien",
      resetEmailSent: "Email envoyé !",
      resetEmailSentDesc: "Vérifiez votre boîte de réception. Le lien expire dans 1 heure.",
      backToLogin: "Retour à la connexion",
      newPassword: "Nouveau mot de passe",
      chooseNewPassword: "Choisissez un nouveau mot de passe pour votre compte",
      resetPassword: "Réinitialiser le mot de passe",
      invalidResetLink: "Ce lien est invalide ou a expiré.",
      requestNewLink: "Demander un nouveau lien",
      passwordUpdated: "Mot de passe mis à jour !",
      passwordUpdatedDesc: "Votre mot de passe a été changé. Vous pouvez maintenant vous connecter.",
      changePassword: "Changer le mot de passe",
      changePasswordDesc: "Mettez à jour le mot de passe de votre compte",
      currentPassword: "Mot de passe actuel",
      passwordChanged: "Mot de passe changé avec succès",
      passwordMismatch: "Les mots de passe ne correspondent pas",
      passwordTooShort: "Mot de passe trop court (min. 6 caractères)",
      confirm: "Confirmer",
      minChars: "Min. 6 caractères"
    },
    dashboard: {
      welcome: "Bienvenue",
      upcomingBookings: "Réservations à venir",
      pendingRequests: "Demandes en attente",
      pastBookings: "Réservations passées",
      quickActions: "Actions rapides",
      findProvider: "Trouver un prestataire",
      myMessages: "Mes messages",
      totalEarnings: "Revenus totaux",
      monthEarnings: "Ce mois",
      completedMissions: "Missions terminées",
      rankProgress: "Progression de rang",
      editProfile: "Modifier le profil"
    },
    review: {
      leaveReview: "Laisser un avis",
      rating: "Note",
      comment: "Commentaire",
      publish: "Publier",
      noReviews: "Aucun avis pour le moment"
    },
    messages: {
      title: "Messages",
      noConversations: "Aucune conversation",
      selectConversation: "Sélectionnez une conversation",
      typeMessage: "Écrivez votre message...",
      send: "Envoyer"
    },
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      save: "Sauvegarder",
      cancel: "Annuler",
      back: "Retour",
      next: "Suivant",
      manage: "Gérer",
      noResults: "Aucun résultat trouvé",
      clearFilters: "Effacer les filtres",
      filters: "Filtres",
      priceRange: "Fourchette de prix",
      language: "Langue",
      hours: "heures",
      person: "personne",
      people: "personnes"
    },
    footer: {
      tagline: "Réservez des professionnels de confiance pour tous vos services personnels à Hamburg.",
      navigation: "Navigation",
      support: "Support",
      faq: "FAQ",
      contact: "Contact",
      privacy: "Politique de confidentialité",
      rights: "Tous droits réservés"
    },
    verification: {
      pendingTitle: "Compte en attente de vérification",
      pendingMessage: "Votre profil est en cours de vérification par notre équipe. Vous ne pouvez pas encore apparaître dans les recherches ni publier de contenu.",
      rejectedTitle: "Vérification rejetée",
      rejectedMessage: "Votre demande a été rejetée. Veuillez mettre à jour vos documents et réessayer.",
      cannotPost: "Votre compte est en attente de vérification. Vous ne pouvez pas encore publier."
    },
    blog: {
      myPosts: "Mes Publications",
      publication: "publication",
      publications: "publications",
      newPost: "Publier",
      noPosts: "Aucune publication",
      noPostsSubtitle: "Partagez vos réalisations et attirez de nouveaux clients !",
      createFirst: "Créer ma première publication",
      newPostTitle: "Nouvelle publication",
      addPhotos: "Ajouter des photos",
      describeWork: "Décrivez votre réalisation...",
      publish: "Publier",
      publishing: "Publication en cours...",
      postCreated: "Publication créée !",
      deleteConfirm: "Supprimer cette publication ?",
      postDeleted: "Publication supprimée",
      viewPosts: "Voir les publications",
      backToProfile: "Retour au profil",
      viewProfile: "Voir profil",
      noPostsYet: "Aucune publication pour le moment",
      noComments: "Aucun commentaire",
      addComment: "Ajouter un commentaire...",
      loginToLike: "Connectez-vous pour liker",
      loginToComment: "Connectez-vous pour commenter",
      justNow: "à l'instant",
      minutesAgo: "min",
      hoursAgo: "h",
      daysAgo: "j"
    },
    invoice: {
      title: "Facture",
      generate: "Générer la facture",
      view: "Voir la facture",
      sent: "Facture envoyée",
      providerRate: "Tarif prestataire",
      serviceDuration: "Durée du service",
      subtotal: "Sous-total (prestataire)",
      commission: "Commission plateforme",
      commissionRate: "Taux de commission",
      totalCharged: "Total facturé",
      invoiceNumber: "Facture n°",
      invoiceDate: "Date de facture",
      serviceDate: "Date du service",
      billTo: "Facturé à",
      serviceBy: "Service par",
      noInvoice: "Pas encore de facture",
      generating: "Génération en cours...",
      generated: "Facture générée",
      priceIncludesCommission: "Prix incluant les frais de service"
    },
    payment: {
      checking: "Vérification du paiement...",
      pleaseWait: "Veuillez patienter pendant que nous confirmons votre paiement.",
      success: "Paiement réussi !",
      confirmed: "Votre réservation a été confirmée.",
      viewBookings: "Voir mes réservations",
      backHome: "Retour à l'accueil",
      processing: "Paiement en cours de traitement",
      processingDesc: "Votre paiement est en cours de traitement. Vous recevrez une confirmation par email.",
      error: "Erreur de paiement",
      errorDesc: "Une erreur est survenue lors du paiement. Veuillez réessayer.",
      backToBookings: "Retourner aux réservations",
      expired: "Session expirée"
    },
    bank: {
      title: "Coordonnées bancaires",
      description: "Entrez vos coordonnées bancaires pour recevoir les paiements de vos prestations.",
      accountHolder: "Titulaire du compte",
      bankName: "Nom de la banque",
      save: "Enregistrer les coordonnées",
      saved: "Coordonnées bancaires enregistrées"
    }
  },
  it: {
    nav: {
      services: "Servizi",
      providers: "Professionisti",
      login: "Accedi",
      register: "Registrati",
      dashboard: "Dashboard",
      bookings: "Le Mie Prenotazioni",
      messages: "Messaggi",
      profile: "Il Mio Profilo",
      logout: "Esci",
      becomeProvider: "Diventa Professionista"
    },
    home: {
      heroTitle: "I tuoi servizi personali,",
      heroTitleAccent: "a casa tua",
      heroSubtitle: "Prenota professionisti di fiducia per tutte le tue esigenze - chef privati, pulizie, fitness coach e altro.",
      searchPlaceholder: "Cerca professionisti, servizi...",
      allCategories: "Tutte le categorie",
      search: "Cerca",
      howItWorks: "Come Funziona",
      howItWorksSubtitle: "Prenota il tuo servizio in pochi clic",
      step1Title: "Scegli un servizio",
      step1Desc: "Sfoglia i professionisti per categoria e specialità",
      step2Title: "Prenota una data",
      step2Desc: "Seleziona giorno, ora e le tue esigenze",
      step3Title: "Paga in sicurezza",
      step3Desc: "Pagamento sicuro e conferma istantanea",
      featuredProviders: "Professionisti più votati",
      featuredSubtitle: "Scopri i migliori professionisti di Amburgo",
      viewAll: "Vedi tutti",
      stats: {
        providers: "Professionisti",
        bookings: "Prenotazioni completate",
        avgRating: "Valutazione media",
        coverage: "Copertura Amburgo"
      },
      ctaTitle: "Sei un professionista?",
      ctaSubtitle: "Unisciti alla nostra piattaforma e offri i tuoi servizi ai clienti di Amburgo.",
      ctaButton: "Diventa Partner"
    },
    categories: {
      chef: "Chef Privato",
      cleaning: "Pulizie",
      babysitting: "Babysitting",
      tutoring: "Ripetizioni",
      fitness: "Coach Fitness",
      beauty: "Bellezza & Benessere",
      handyman: "Tuttofare",
      gardening: "Giardinaggio",
      pet_care: "Cura Animali",
      elderly_care: "Assistenza Anziani"
    },
    ranks: {
      pro: "Pro",
      elite: "Elite",
      master: "Maestro",
      grandmaster: "Gran Maestro",
      legendary: "Leggendario"
    },
    provider: {
      perHour: "/ora",
      minHours: "Min",
      maxCapacity: "Max",
      available: "Disponibile",
      unavailable: "Non disponibile",
      reviews: "recensioni",
      missions: "missioni",
      commission: "Commissione",
      specialties: "Specialità",
      languages: "Lingue",
      bookNow: "Prenota Ora",
      contactProvider: "Contatta",
      gallery: "Galleria",
      about: "Info"
    },
    booking: {
      createBooking: "Prenota",
      date: "Data evento",
      time: "Ora inizio",
      duration: "Durata (ore)",
      capacity: "Numero persone",
      address: "Indirizzo",
      phone: "Telefono",
      notes: "Note (opzionale)",
      subtotal: "Subtotale",
      serviceFee: "Costo servizio",
      total: "Totale",
      confirm: "Conferma prenotazione",
      pending: "In attesa",
      confirmed: "Confermata",
      paid: "Pagata",
      completed: "Completata",
      cancelled: "Annullata",
      payNow: "Paga ora",
      cancel: "Annulla",
      accept: "Accetta",
      decline: "Rifiuta",
      complete: "Completa"
    },
    auth: {
      loginTitle: "Accedi",
      loginSubtitle: "Accedi al tuo account per gestire le prenotazioni",
      registerTitle: "Crea Account",
      registerSubtitle: "Unisciti alla community AFY",
      email: "Email",
      password: "Password",
      confirmPassword: "Conferma password",
      name: "Nome completo",
      client: "Cliente",
      provider: "Professionista",
      continueGoogle: "Continua con Google",
      orEmail: "o via email",
      submit: "Invia",
      noAccount: "Non hai un account?",
      hasAccount: "Hai già un account?",
      createAccount: "Crea account",
      forgotPassword: "Password dimenticata?",
      forgotPasswordSubtitle: "Inserisci la tua email e ti invieremo un link per reimpostare la password",
      sendResetLink: "Invia link",
      resetEmailSent: "Email inviata!",
      resetEmailSentDesc: "Controlla la tua casella di posta. Il link scade tra 1 ora.",
      backToLogin: "Torna al login",
      newPassword: "Nuova password",
      chooseNewPassword: "Scegli una nuova password per il tuo account",
      resetPassword: "Reimposta password",
      invalidResetLink: "Questo link non è valido o è scaduto.",
      requestNewLink: "Richiedi un nuovo link",
      passwordUpdated: "Password aggiornata!",
      passwordUpdatedDesc: "La tua password è stata cambiata. Ora puoi accedere.",
      changePassword: "Cambia password",
      changePasswordDesc: "Aggiorna la password del tuo account",
      currentPassword: "Password attuale",
      passwordChanged: "Password cambiata con successo",
      passwordMismatch: "Le password non corrispondono",
      passwordTooShort: "Password troppo corta (min. 6 caratteri)"
    },
    dashboard: {
      welcome: "Benvenuto",
      upcomingBookings: "Prossime prenotazioni",
      pendingRequests: "Richieste in attesa",
      pastBookings: "Prenotazioni passate",
      quickActions: "Azioni rapide",
      findProvider: "Trova professionista",
      myMessages: "I miei messaggi",
      totalEarnings: "Guadagni totali",
      monthEarnings: "Questo mese",
      completedMissions: "Missioni completate",
      rankProgress: "Progresso rango",
      editProfile: "Modifica profilo"
    },
    review: {
      leaveReview: "Lascia una recensione",
      rating: "Valutazione",
      comment: "Commento",
      publish: "Pubblica",
      noReviews: "Nessuna recensione"
    },
    messages: {
      title: "Messaggi",
      noConversations: "Nessuna conversazione",
      selectConversation: "Seleziona una conversazione",
      typeMessage: "Scrivi il tuo messaggio...",
      send: "Invia"
    },
    common: {
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      save: "Salva",
      cancel: "Annulla",
      back: "Indietro",
      next: "Avanti",
      noResults: "Nessun risultato trovato",
      clearFilters: "Cancella filtri",
      filters: "Filtri",
      priceRange: "Fascia di prezzo",
      language: "Lingua",
      hours: "ore",
      person: "persona",
      people: "persone"
    },
    footer: {
      tagline: "Prenota professionisti di fiducia per tutti i tuoi servizi personali ad Amburgo.",
      navigation: "Navigazione",
      support: "Supporto",
      faq: "FAQ",
      contact: "Contatto",
      privacy: "Privacy",
      rights: "Tutti i diritti riservati"
    },
    verification: {
      pendingTitle: "Account in attesa di verifica",
      pendingMessage: "Il tuo profilo è in fase di revisione da parte del nostro team. Non puoi ancora apparire nelle ricerche o pubblicare contenuti.",
      rejectedTitle: "Verifica rifiutata",
      rejectedMessage: "La tua richiesta è stata rifiutata. Aggiorna i tuoi documenti e riprova.",
      cannotPost: "Il tuo account è in attesa di verifica. Non puoi ancora pubblicare."
    },
    blog: {
      myPosts: "Le Mie Pubblicazioni",
      publication: "pubblicazione",
      publications: "pubblicazioni",
      newPost: "Pubblica",
      noPosts: "Nessuna pubblicazione",
      noPostsSubtitle: "Condividi il tuo lavoro e attira nuovi clienti!",
      createFirst: "Crea la mia prima pubblicazione",
      newPostTitle: "Nuova pubblicazione",
      addPhotos: "Aggiungi foto",
      describeWork: "Descrivi il tuo lavoro...",
      publish: "Pubblica",
      publishing: "Pubblicazione in corso...",
      postCreated: "Pubblicazione creata!",
      deleteConfirm: "Eliminare questa pubblicazione?",
      postDeleted: "Pubblicazione eliminata",
      viewPosts: "Vedi pubblicazioni",
      backToProfile: "Torna al profilo",
      viewProfile: "Vedi profilo",
      noPostsYet: "Nessuna pubblicazione al momento",
      noComments: "Nessun commento",
      addComment: "Aggiungi un commento...",
      loginToLike: "Accedi per mettere mi piace",
      loginToComment: "Accedi per commentare",
      justNow: "adesso",
      minutesAgo: "min",
      hoursAgo: "h",
      daysAgo: "g"
    },
    invoice: {
      title: "Fattura",
      generate: "Genera fattura",
      view: "Vedi fattura",
      sent: "Fattura inviata",
      providerRate: "Tariffa professionista",
      serviceDuration: "Durata servizio",
      subtotal: "Subtotale (professionista)",
      commission: "Commissione piattaforma",
      commissionRate: "Tasso di commissione",
      totalCharged: "Totale addebitato",
      invoiceNumber: "Fattura n.",
      invoiceDate: "Data fattura",
      serviceDate: "Data servizio",
      billTo: "Fatturato a",
      serviceBy: "Servizio di",
      noInvoice: "Nessuna fattura ancora",
      generating: "Generazione...",
      generated: "Fattura generata",
      priceIncludesCommission: "Prezzo incluse le spese di servizio"
    },
    payment: {
      checking: "Verifica del pagamento...",
      pleaseWait: "Attendere prego mentre confermiamo il pagamento.",
      success: "Pagamento riuscito!",
      confirmed: "La tua prenotazione è stata confermata.",
      viewBookings: "Vedi le mie prenotazioni",
      backHome: "Torna alla home",
      processing: "Pagamento in elaborazione",
      processingDesc: "Il pagamento è in fase di elaborazione. Riceverai una conferma via email.",
      error: "Errore di pagamento",
      errorDesc: "Si è verificato un errore durante il pagamento. Riprova.",
      backToBookings: "Torna alle prenotazioni",
      expired: "Sessione scaduta"
    },
    bank: {
      title: "Coordinate bancarie",
      description: "Inserisci i tuoi dati bancari per ricevere i pagamenti per i tuoi servizi.",
      accountHolder: "Intestatario del conto",
      bankName: "Nome della banca",
      save: "Salva coordinate bancarie",
      saved: "Coordinate bancarie salvate"
    }
  },
  es: {
    nav: {
      services: "Servicios",
      providers: "Profesionales",
      login: "Iniciar sesión",
      register: "Registrarse",
      dashboard: "Panel",
      bookings: "Mis Reservas",
      messages: "Mensajes",
      profile: "Mi Perfil",
      logout: "Cerrar sesión",
      becomeProvider: "Ser Profesional"
    },
    home: {
      heroTitle: "Tus servicios personales,",
      heroTitleAccent: "en tu puerta",
      heroSubtitle: "Reserva profesionales de confianza para todas tus necesidades - chefs privados, limpieza, fitness y más.",
      searchPlaceholder: "Buscar profesionales, servicios...",
      allCategories: "Todas las categorías",
      search: "Buscar",
      howItWorks: "Cómo Funciona",
      howItWorksSubtitle: "Reserva tu servicio en pocos clics",
      step1Title: "Elige un servicio",
      step1Desc: "Explora profesionales por categoría y especialidad",
      step2Title: "Reserva una fecha",
      step2Desc: "Selecciona día, hora y tus requisitos",
      step3Title: "Paga seguro",
      step3Desc: "Pago seguro y confirmación instantánea",
      featuredProviders: "Profesionales mejor valorados",
      featuredSubtitle: "Descubre los mejores profesionales de Hamburgo",
      viewAll: "Ver todos",
      stats: {
        providers: "Profesionales",
        bookings: "Reservas completadas",
        avgRating: "Valoración media",
        coverage: "Cobertura Hamburgo"
      },
      ctaTitle: "¿Eres profesional?",
      ctaSubtitle: "Únete a nuestra plataforma y ofrece tus servicios a clientes de Hamburgo.",
      ctaButton: "Ser Partner"
    },
    categories: {
      chef: "Chef Privado",
      cleaning: "Limpieza",
      babysitting: "Cuidado de niños",
      tutoring: "Clases particulares",
      fitness: "Entrenador personal",
      beauty: "Belleza y Bienestar",
      handyman: "Manitas",
      gardening: "Jardinería",
      pet_care: "Cuidado de mascotas",
      elderly_care: "Cuidado de mayores"
    },
    ranks: {
      pro: "Pro",
      elite: "Élite",
      master: "Maestro",
      grandmaster: "Gran Maestro",
      legendary: "Legendario"
    },
    provider: {
      perHour: "/hora",
      minHours: "Mín",
      maxCapacity: "Máx",
      available: "Disponible",
      unavailable: "No disponible",
      reviews: "reseñas",
      missions: "misiones",
      commission: "Comisión",
      specialties: "Especialidades",
      languages: "Idiomas",
      bookNow: "Reservar",
      contactProvider: "Contactar",
      gallery: "Galería",
      about: "Acerca de"
    },
    booking: {
      createBooking: "Reservar",
      date: "Fecha del evento",
      time: "Hora de inicio",
      duration: "Duración (horas)",
      capacity: "Número de personas",
      address: "Dirección",
      phone: "Teléfono",
      notes: "Notas (opcional)",
      subtotal: "Subtotal",
      serviceFee: "Tarifa de servicio",
      total: "Total",
      confirm: "Confirmar reserva",
      pending: "Pendiente",
      confirmed: "Confirmada",
      paid: "Pagada",
      completed: "Completada",
      cancelled: "Cancelada",
      payNow: "Pagar ahora",
      cancel: "Cancelar",
      accept: "Aceptar",
      decline: "Rechazar",
      complete: "Marcar completada"
    },
    auth: {
      loginTitle: "Iniciar sesión",
      loginSubtitle: "Accede a tu cuenta para gestionar tus reservas",
      registerTitle: "Crear cuenta",
      registerSubtitle: "Únete a la comunidad AFY",
      email: "Email",
      password: "Contraseña",
      confirmPassword: "Confirmar contraseña",
      name: "Nombre completo",
      client: "Cliente",
      provider: "Profesional",
      continueGoogle: "Continuar con Google",
      orEmail: "o por email",
      submit: "Enviar",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      createAccount: "Crear cuenta",
      forgotPassword: "¿Olvidaste tu contraseña?",
      forgotPasswordSubtitle: "Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña",
      sendResetLink: "Enviar enlace",
      resetEmailSent: "¡Email enviado!",
      resetEmailSentDesc: "Revisa tu bandeja de entrada. El enlace expira en 1 hora.",
      backToLogin: "Volver al inicio de sesión",
      newPassword: "Nueva contraseña",
      chooseNewPassword: "Elige una nueva contraseña para tu cuenta",
      resetPassword: "Restablecer contraseña",
      invalidResetLink: "Este enlace no es válido o ha expirado.",
      requestNewLink: "Solicitar un nuevo enlace",
      passwordUpdated: "¡Contraseña actualizada!",
      passwordUpdatedDesc: "Tu contraseña ha sido cambiada. Ahora puedes iniciar sesión.",
      changePassword: "Cambiar contraseña",
      changePasswordDesc: "Actualiza la contraseña de tu cuenta",
      currentPassword: "Contraseña actual",
      passwordChanged: "Contraseña cambiada con éxito",
      passwordMismatch: "Las contraseñas no coinciden",
      passwordTooShort: "Contraseña muy corta (mín. 6 caracteres)"
    },
    dashboard: {
      welcome: "Bienvenido",
      upcomingBookings: "Próximas reservas",
      pendingRequests: "Solicitudes pendientes",
      pastBookings: "Reservas pasadas",
      quickActions: "Acciones rápidas",
      findProvider: "Buscar profesional",
      myMessages: "Mis mensajes",
      totalEarnings: "Ganancias totales",
      monthEarnings: "Este mes",
      completedMissions: "Misiones completadas",
      rankProgress: "Progreso de rango",
      editProfile: "Editar perfil"
    },
    review: {
      leaveReview: "Dejar una reseña",
      rating: "Valoración",
      comment: "Comentario",
      publish: "Publicar",
      noReviews: "Sin reseñas aún"
    },
    messages: {
      title: "Mensajes",
      noConversations: "Sin conversaciones",
      selectConversation: "Selecciona una conversación",
      typeMessage: "Escribe tu mensaje...",
      send: "Enviar"
    },
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      save: "Guardar",
      cancel: "Cancelar",
      back: "Atrás",
      next: "Siguiente",
      noResults: "Sin resultados",
      clearFilters: "Limpiar filtros",
      filters: "Filtros",
      priceRange: "Rango de precio",
      language: "Idioma",
      hours: "horas",
      person: "persona",
      people: "personas"
    },
    footer: {
      tagline: "Reserva profesionales de confianza para todos tus servicios personales en Hamburgo.",
      navigation: "Navegación",
      support: "Soporte",
      faq: "FAQ",
      contact: "Contacto",
      privacy: "Privacidad",
      rights: "Todos los derechos reservados"
    },
    verification: {
      pendingTitle: "Cuenta en espera de verificación",
      pendingMessage: "Tu perfil está siendo revisado por nuestro equipo. Aún no puedes aparecer en las búsquedas ni publicar contenido.",
      rejectedTitle: "Verificación rechazada",
      rejectedMessage: "Tu solicitud ha sido rechazada. Actualiza tus documentos e inténtalo de nuevo.",
      cannotPost: "Tu cuenta está en espera de verificación. Aún no puedes publicar."
    },
    blog: {
      myPosts: "Mis Publicaciones",
      publication: "publicación",
      publications: "publicaciones",
      newPost: "Publicar",
      noPosts: "Sin publicaciones",
      noPostsSubtitle: "¡Comparte tu trabajo y atrae nuevos clientes!",
      createFirst: "Crear mi primera publicación",
      newPostTitle: "Nueva publicación",
      addPhotos: "Añadir fotos",
      describeWork: "Describe tu trabajo...",
      publish: "Publicar",
      publishing: "Publicando...",
      postCreated: "¡Publicación creada!",
      deleteConfirm: "¿Eliminar esta publicación?",
      postDeleted: "Publicación eliminada",
      viewPosts: "Ver publicaciones",
      backToProfile: "Volver al perfil",
      viewProfile: "Ver perfil",
      noPostsYet: "Sin publicaciones por el momento",
      noComments: "Sin comentarios",
      addComment: "Añadir un comentario...",
      loginToLike: "Inicia sesión para dar me gusta",
      loginToComment: "Inicia sesión para comentar",
      justNow: "ahora mismo",
      minutesAgo: "min",
      hoursAgo: "h",
      daysAgo: "d"
    },
    invoice: {
      title: "Factura",
      generate: "Generar factura",
      view: "Ver factura",
      sent: "Factura enviada",
      providerRate: "Tarifa profesional",
      serviceDuration: "Duración del servicio",
      subtotal: "Subtotal (profesional)",
      commission: "Comisión plataforma",
      commissionRate: "Tasa de comisión",
      totalCharged: "Total facturado",
      invoiceNumber: "Factura n.º",
      invoiceDate: "Fecha factura",
      serviceDate: "Fecha servicio",
      billTo: "Facturado a",
      serviceBy: "Servicio por",
      noInvoice: "Sin factura aún",
      generating: "Generando...",
      generated: "Factura generada",
      priceIncludesCommission: "Precio incluye gastos de servicio"
    },
    payment: {
      checking: "Verificando pago...",
      pleaseWait: "Por favor espere mientras confirmamos su pago.",
      success: "¡Pago exitoso!",
      confirmed: "Su reserva ha sido confirmada.",
      viewBookings: "Ver mis reservas",
      backHome: "Volver al inicio",
      processing: "Pago en proceso",
      processingDesc: "Su pago está siendo procesado. Recibirá una confirmación por email.",
      error: "Error de pago",
      errorDesc: "Ocurrió un error durante el pago. Inténtelo de nuevo.",
      backToBookings: "Volver a las reservas",
      expired: "Sesión expirada"
    },
    bank: {
      title: "Datos bancarios",
      description: "Ingrese sus datos bancarios para recibir los pagos de sus servicios.",
      accountHolder: "Titular de la cuenta",
      bankName: "Nombre del banco",
      save: "Guardar datos bancarios",
      saved: "Datos bancarios guardados"
    }
  }
};

// Language names for display
export const languageNames = {
  en: { native: "English", flag: "🇬🇧" },
  de: { native: "Deutsch", flag: "🇩🇪" },
  fr: { native: "Français", flag: "🇫🇷" },
  it: { native: "Italiano", flag: "🇮🇹" },
  es: { native: "Español", flag: "🇪🇸" }
};

// Admin translations
export const adminTranslations = {
  en: {
    dashboard: {
      title: "Admin Dashboard",
      subtitle: "Overview of your platform",
      totalUsers: "Total Users",
      providers: "Providers",
      clients: "Clients",
      bookings: "Bookings",
      revenue: "Total Revenue",
      users: "Users",
      verifications: "Verifications",
      advertising: "Advertising",
      settings: "Settings",
      commission: "Commission",
      payouts: "Payouts",
      vouchers: "Vouchers",
      stripeDashboard: "Stripe Dashboard"
    },
    login: {
      title: "Admin Portal",
      subtitle: "Secure access for administrators only",
      authTitle: "Administrator Authentication",
      emailLabel: "Admin Email",
      passwordLabel: "Password",
      passwordPlaceholder: "Enter your password",
      submitButton: "Access Admin Panel",
      authenticating: "Authenticating...",
      footerText: "This portal is reserved for authorized administrators only.",
      notAdmin: "Not an administrator?",
      backToLogin: "Back to main login",
      invalidCredentials: "Invalid credentials",
      connectionError: "Connection error"
    },
    stripe: {
      title: "Stripe Dashboard",
      subtitle: "Platform revenue in real-time",
      availableBalance: "Available Balance",
      pendingBalance: "Pending",
      platformRevenue: "Revenue",
      transactions: "Transactions",
      totalVolume: "Total Volume",
      platform: "Platform",
      providers: "Providers",
      revenueChart: "Platform revenue (last 14 days)",
      connectedAccounts: "Connected Accounts",
      active: "active",
      recentTransactions: "Recent Transactions",
      noTransactions: "No recent transactions",
      noConnectedAccounts: "No connected accounts",
      providersNeedStripe: "Providers need to set up Stripe Connect",
      productionMode: "Production Mode",
      testMode: "Test Mode",
      refresh: "Refresh",
      setup: {
        title: "Stripe Configuration",
        subtitle: "Configure your account to receive payments",
        accountStatus: "Account Status",
        accountRequired: "Stripe Account Required",
        accountRequiredDesc: "To receive payments and be verified on the platform, you need to create and configure your Stripe account.",
        createAccount: "Create my Stripe account",
        completeOnboarding: "Complete Onboarding",
        openDashboard: "Open Stripe Dashboard",
        accountCreated: "Account created",
        onboardingComplete: "Onboarding complete",
        paymentsEnabled: "Payments enabled",
        payoutsEnabled: "Payouts enabled",
        allSet: "All set!",
        allSetDesc: "Your Stripe account is fully configured. You can receive payments.",
        pendingVerification: "Pending verification",
        pendingVerificationDesc: "Your account needs additional verification. Click below to complete the setup.",
        howItWorks: "How it works?",
        step1: "Create your Stripe account",
        step1Desc: "Sign up with your email and basic information",
        step2: "Verify your identity",
        step2Desc: "Provide ID and bank details",
        step3: "Receive payments",
        step3Desc: "Your clients' payments go directly to your account",
        connectNotEnabled: "Stripe Connect is not enabled. The administrator must enable it at dashboard.stripe.com/connect",
        contactAdmin: "Contact the administrator to enable Stripe Connect on the platform account."
      }
    },
    vouchers: {
      title: "Voucher Management",
      subtitle: "Create and manage discount vouchers for clients",
      createVoucher: "Create Voucher",
      editVoucher: "Edit Voucher",
      deleteVoucher: "Delete Voucher",
      code: "Voucher Code",
      discountType: "Discount Type",
      percentage: "Percentage (%)",
      fixedAmount: "Fixed Amount (€)",
      discountValue: "Discount Value",
      minBooking: "Minimum Booking (€)",
      maxUses: "Max Uses",
      unlimited: "Unlimited",
      validUntil: "Valid Until",
      description: "Description",
      active: "Active",
      inactive: "Inactive",
      expired: "Expired",
      used: "Used",
      noVouchers: "No vouchers found",
      createFirst: "Create your first voucher to offer discounts to clients",
      confirmDelete: "Are you sure you want to delete this voucher?",
      cannotUndo: "This action cannot be undone."
    },
    providers: {
      title: "Provider Management",
      search: "Search providers...",
      commission: "Commission",
      customCommission: "Custom Commission",
      globalRate: "Global Rate",
      effectiveRate: "Effective Rate",
      setCustomRate: "Set custom commission rate for this provider",
      useGlobal: "Use global rate",
      save: "Save",
      cancel: "Cancel"
    },
    common: {
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      search: "Search",
      filter: "Filter",
      export: "Export",
      refresh: "Refresh",
      loading: "Loading...",
      noData: "No data available",
      actions: "Actions",
      status: "Status",
      date: "Date",
      amount: "Amount"
    }
  },
  fr: {
    dashboard: {
      title: "Tableau de bord Admin",
      subtitle: "Vue d'ensemble de votre plateforme",
      totalUsers: "Utilisateurs totaux",
      providers: "Prestataires",
      clients: "Clients",
      bookings: "Réservations",
      revenue: "Revenus totaux",
      users: "Utilisateurs",
      verifications: "Vérifications",
      advertising: "Publicités",
      settings: "Paramètres",
      commission: "Commission",
      payouts: "Reversements",
      vouchers: "Vouchers",
      stripeDashboard: "Stripe Dashboard"
    },
    login: {
      title: "Portail Admin",
      subtitle: "Accès sécurisé réservé aux administrateurs",
      authTitle: "Authentification Administrateur",
      emailLabel: "Email Admin",
      passwordLabel: "Mot de passe",
      passwordPlaceholder: "Entrez votre mot de passe",
      submitButton: "Accéder au Panel Admin",
      authenticating: "Authentification...",
      footerText: "Ce portail est réservé aux administrateurs autorisés uniquement.",
      notAdmin: "Pas administrateur ?",
      backToLogin: "Retour à la connexion principale",
      invalidCredentials: "Identifiants invalides",
      connectionError: "Erreur de connexion"
    },
    stripe: {
      title: "Stripe Dashboard",
      subtitle: "Revenus de la plateforme en temps réel",
      availableBalance: "Solde disponible",
      pendingBalance: "En attente",
      platformRevenue: "Revenus",
      transactions: "Transactions",
      totalVolume: "Volume total",
      platform: "Plateforme",
      providers: "Prestataires",
      revenueChart: "Revenus plateforme (14 derniers jours)",
      connectedAccounts: "Comptes connectés",
      active: "actifs",
      recentTransactions: "Dernières transactions",
      noTransactions: "Aucune transaction récente",
      noConnectedAccounts: "Aucun compte connecté",
      providersNeedStripe: "Les prestataires doivent configurer Stripe Connect",
      productionMode: "Mode Production",
      testMode: "Mode Test",
      refresh: "Actualiser",
      setup: {
        title: "Configuration Stripe",
        subtitle: "Configurez votre compte pour recevoir des paiements",
        accountStatus: "Statut du compte",
        accountRequired: "Compte Stripe requis",
        accountRequiredDesc: "Pour recevoir des paiements et être vérifié sur la plateforme, vous devez créer et configurer votre compte Stripe.",
        createAccount: "Créer mon compte Stripe",
        completeOnboarding: "Compléter l'onboarding",
        openDashboard: "Ouvrir le Dashboard Stripe",
        accountCreated: "Compte créé",
        onboardingComplete: "Onboarding complété",
        paymentsEnabled: "Paiements activés",
        payoutsEnabled: "Versements activés",
        allSet: "Tout est prêt !",
        allSetDesc: "Votre compte Stripe est entièrement configuré. Vous pouvez recevoir des paiements.",
        pendingVerification: "Vérification en attente",
        pendingVerificationDesc: "Votre compte nécessite une vérification supplémentaire. Cliquez ci-dessous pour terminer la configuration.",
        howItWorks: "Comment ça marche ?",
        step1: "Créez votre compte Stripe",
        step1Desc: "Inscrivez-vous avec votre email et vos informations de base",
        step2: "Vérifiez votre identité",
        step2Desc: "Fournissez une pièce d'identité et vos coordonnées bancaires",
        step3: "Recevez des paiements",
        step3Desc: "Les paiements de vos clients vont directement sur votre compte",
        connectNotEnabled: "Stripe Connect n'est pas activé. L'administrateur doit l'activer sur dashboard.stripe.com/connect",
        contactAdmin: "Contactez l'administrateur pour activer Stripe Connect sur le compte de la plateforme."
      }
    },
    vouchers: {
      title: "Gestion des Vouchers",
      subtitle: "Créez et gérez les codes promo pour vos clients",
      createVoucher: "Créer un Voucher",
      editVoucher: "Modifier le Voucher",
      deleteVoucher: "Supprimer le Voucher",
      code: "Code du voucher",
      discountType: "Type de réduction",
      percentage: "Pourcentage (%)",
      fixedAmount: "Montant fixe (€)",
      discountValue: "Valeur de la réduction",
      minBooking: "Réservation minimum (€)",
      maxUses: "Utilisations max",
      unlimited: "Illimité",
      validUntil: "Valide jusqu'au",
      description: "Description",
      active: "Actif",
      inactive: "Inactif",
      expired: "Expiré",
      used: "Utilisé",
      noVouchers: "Aucun voucher trouvé",
      createFirst: "Créez votre premier voucher pour offrir des réductions à vos clients",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ce voucher ?",
      cannotUndo: "Cette action est irréversible."
    },
    providers: {
      title: "Gestion des Prestataires",
      search: "Rechercher un prestataire...",
      commission: "Commission",
      customCommission: "Commission personnalisée",
      globalRate: "Taux global",
      effectiveRate: "Taux effectif",
      setCustomRate: "Définir un taux de commission personnalisé pour ce prestataire",
      useGlobal: "Utiliser le taux global",
      save: "Enregistrer",
      cancel: "Annuler"
    },
    common: {
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      create: "Créer",
      search: "Rechercher",
      filter: "Filtrer",
      export: "Exporter",
      refresh: "Actualiser",
      loading: "Chargement...",
      noData: "Aucune donnée disponible",
      actions: "Actions",
      status: "Statut",
      date: "Date",
      amount: "Montant"
    }
  },
  de: {
    dashboard: {
      title: "Admin-Dashboard",
      subtitle: "Übersicht Ihrer Plattform",
      totalUsers: "Benutzer gesamt",
      providers: "Anbieter",
      clients: "Kunden",
      bookings: "Buchungen",
      revenue: "Gesamtumsatz",
      users: "Benutzer",
      verifications: "Verifizierungen",
      advertising: "Werbung",
      settings: "Einstellungen",
      commission: "Provision",
      payouts: "Auszahlungen",
      vouchers: "Gutscheine",
      stripeDashboard: "Stripe Dashboard"
    },
    login: {
      title: "Admin-Portal",
      subtitle: "Sicherer Zugang nur für Administratoren",
      authTitle: "Administrator-Authentifizierung",
      emailLabel: "Admin-E-Mail",
      passwordLabel: "Passwort",
      passwordPlaceholder: "Passwort eingeben",
      submitButton: "Zum Admin-Panel",
      authenticating: "Authentifizierung...",
      footerText: "Dieses Portal ist nur für autorisierte Administratoren.",
      notAdmin: "Kein Administrator?",
      backToLogin: "Zurück zur Hauptanmeldung",
      invalidCredentials: "Ungültige Anmeldedaten",
      connectionError: "Verbindungsfehler"
    },
    stripe: {
      title: "Stripe Dashboard",
      subtitle: "Plattform-Einnahmen in Echtzeit",
      availableBalance: "Verfügbares Guthaben",
      pendingBalance: "Ausstehend",
      platformRevenue: "Einnahmen",
      transactions: "Transaktionen",
      totalVolume: "Gesamtvolumen",
      platform: "Plattform",
      providers: "Anbieter",
      revenueChart: "Plattform-Einnahmen (letzte 14 Tage)",
      connectedAccounts: "Verbundene Konten",
      active: "aktiv",
      recentTransactions: "Letzte Transaktionen",
      noTransactions: "Keine aktuellen Transaktionen",
      noConnectedAccounts: "Keine verbundenen Konten",
      providersNeedStripe: "Anbieter müssen Stripe Connect einrichten",
      productionMode: "Produktionsmodus",
      testMode: "Testmodus",
      refresh: "Aktualisieren",
      setup: {
        title: "Stripe-Konfiguration",
        subtitle: "Konfigurieren Sie Ihr Konto, um Zahlungen zu erhalten",
        accountStatus: "Kontostatus",
        accountRequired: "Stripe-Konto erforderlich",
        accountRequiredDesc: "Um Zahlungen zu erhalten und auf der Plattform verifiziert zu werden, müssen Sie Ihr Stripe-Konto erstellen und konfigurieren.",
        createAccount: "Mein Stripe-Konto erstellen",
        completeOnboarding: "Onboarding abschließen",
        openDashboard: "Stripe Dashboard öffnen",
        accountCreated: "Konto erstellt",
        onboardingComplete: "Onboarding abgeschlossen",
        paymentsEnabled: "Zahlungen aktiviert",
        payoutsEnabled: "Auszahlungen aktiviert",
        allSet: "Alles bereit!",
        allSetDesc: "Ihr Stripe-Konto ist vollständig konfiguriert. Sie können Zahlungen empfangen.",
        pendingVerification: "Verifizierung ausstehend",
        pendingVerificationDesc: "Ihr Konto benötigt zusätzliche Verifizierung. Klicken Sie unten, um die Einrichtung abzuschließen.",
        howItWorks: "Wie funktioniert es?",
        step1: "Erstellen Sie Ihr Stripe-Konto",
        step1Desc: "Registrieren Sie sich mit Ihrer E-Mail und Ihren Grunddaten",
        step2: "Verifizieren Sie Ihre Identität",
        step2Desc: "Geben Sie Ihren Ausweis und Ihre Bankdaten an",
        step3: "Empfangen Sie Zahlungen",
        step3Desc: "Die Zahlungen Ihrer Kunden gehen direkt auf Ihr Konto",
        connectNotEnabled: "Stripe Connect ist nicht aktiviert. Der Administrator muss es unter dashboard.stripe.com/connect aktivieren",
        contactAdmin: "Kontaktieren Sie den Administrator, um Stripe Connect auf dem Plattformkonto zu aktivieren."
      }
    },
    vouchers: {
      title: "Gutscheinverwaltung",
      subtitle: "Erstellen und verwalten Sie Rabattgutscheine für Kunden",
      createVoucher: "Gutschein erstellen",
      editVoucher: "Gutschein bearbeiten",
      deleteVoucher: "Gutschein löschen",
      code: "Gutscheincode",
      discountType: "Rabattart",
      percentage: "Prozentsatz (%)",
      fixedAmount: "Festbetrag (€)",
      discountValue: "Rabattwert",
      minBooking: "Mindestbuchung (€)",
      maxUses: "Max. Verwendungen",
      unlimited: "Unbegrenzt",
      validUntil: "Gültig bis",
      description: "Beschreibung",
      active: "Aktiv",
      inactive: "Inaktiv",
      expired: "Abgelaufen",
      used: "Verwendet",
      noVouchers: "Keine Gutscheine gefunden",
      createFirst: "Erstellen Sie Ihren ersten Gutschein für Kundenrabatte",
      confirmDelete: "Möchten Sie diesen Gutschein wirklich löschen?",
      cannotUndo: "Diese Aktion kann nicht rückgängig gemacht werden."
    },
    providers: {
      title: "Anbieterverwaltung",
      search: "Anbieter suchen...",
      commission: "Provision",
      customCommission: "Individuelle Provision",
      globalRate: "Globaler Satz",
      effectiveRate: "Effektiver Satz",
      setCustomRate: "Individuellen Provisionssatz für diesen Anbieter festlegen",
      useGlobal: "Globalen Satz verwenden",
      save: "Speichern",
      cancel: "Abbrechen"
    },
    common: {
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      edit: "Bearbeiten",
      create: "Erstellen",
      search: "Suchen",
      filter: "Filtern",
      export: "Exportieren",
      refresh: "Aktualisieren",
      loading: "Wird geladen...",
      noData: "Keine Daten verfügbar",
      actions: "Aktionen",
      status: "Status",
      date: "Datum",
      amount: "Betrag"
    }
  }
};

// Detect browser language - default to German for Hamburg launch
export const detectLanguage = () => {
  return 'de';
};

// Merge admin translations into main translations
Object.keys(adminTranslations).forEach(lang => {
  if (translations[lang]) {
    translations[lang].admin = adminTranslations[lang];
  }
});

export default translations;
